import { render, staticRenderFns } from "./DisciplinaryNew.vue?vue&type=template&id=15793d70"
import script from "./DisciplinaryNew.vue?vue&type=script&lang=js"
export * from "./DisciplinaryNew.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports